import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/common/Buttons/Button';
import ThreeppModal from 'components/common/Modal/Modal';

import './RequiredFieldsValidationModal.scss';
import CloseIcon from '@mui/icons-material/Close';

export const RequiredFieldsValidationModal = props => {
  const { toggle, isOpen } = props;
  const { t } = useTranslation();

  const close = useCallback(() => {
    toggle();
  }, [toggle]);

  const refreshPage = () => {
    window.location.reload(true);
  };

  return (
    <>
      <ThreeppModal closeButton isOpen={isOpen} toggle={toggle} classes="submit-modal" size="sm">
        <CloseIcon className="close-icon" onClick={close} />
        <div className="submit-content">{t('assessment.simultaneousEdit.pendingRefresh')}</div>
        <div className="action-row">
          <Button className="btn-cancel" buttonStyle="destructive" onClick={close}>
            {t('common.cancel')}
          </Button>

          <Button className="btn-submit" buttonStyle="primary" onClick={refreshPage}>
            {t('assessment.simultaneousEdit.refresh')}
          </Button>
        </div>
      </ThreeppModal>
    </>
  );
};
